import { inject } from '@angular/core';
import { type CanActivateFn } from '@angular/router';

import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);

  if (auth.isAuthenticated()) {
    return true;
  }

  auth.rememberPostLoginUrl(state.url);
  auth.login();
  return false;
};
